import React from 'react';
import T from 'components/T';
import CandidateStoryItemTextField from '../Common/CandidateStoryItemTextField';

type Props = {
  charge: string;
  disabled: boolean;
  field: string;
};

const CaseInformationTextForm = ({ charge, disabled, field }: Props) => {
  return (
    <div
      className='form-group'
      hidden={disabled}
      data-testid='candidate-stories-legacy-case-information-text-form'
    >
      <p>
        <T
          value='components.Report.CandidateStories.Modal.CaseInformation.description'
          chargeName={charge}
          dangerousHTML
        />
      </p>

      <ul className='text-muted'>
        <T value='components.Report.examples' />
        <li>
          <T value='components.Report.CandidateStories.Modal.CaseInformation.example1' />
        </li>
        <li>
          <T value='components.Report.CandidateStories.Modal.CaseInformation.example2' />
        </li>
        <li>
          <T value='components.Report.CandidateStories.Modal.CaseInformation.example3' />
        </li>
      </ul>

      <CandidateStoryItemTextField field={field} />
    </div>
  );
};

export default CaseInformationTextForm;
